/**
 * Autotiles do acervo, tile a tile.
 *
 * O RPG Maker não guarda o desenho de cada casa: guarda um número que diz qual
 * autotile é e QUAL FORMA ele tem, e a forma é resolvida montando quatro
 * quadrantes de 24×24 tirados de posições diferentes da folha. As tabelas
 * abaixo são o mapa dessa montagem, e vieram do próprio acervo — reescrevê-las
 * à mão seria adivinhar 48 formas de cada vez.
 *
 * Cada entrada é uma forma; cada forma tem quatro pares [coluna, linha] em
 * unidades de meio tile, na ordem superior-esquerdo, superior-direito,
 * inferior-esquerdo, inferior-direito.
 */

export type Quadrant = readonly [number, number];
export type ShapeTable = readonly (readonly Quadrant[])[];

export const FLOOR_AUTOTILE_TABLE: ShapeTable = [
  [[2,4], [1,4], [2,3], [1,3]],
  [[2,0], [1,4], [2,3], [1,3]],
  [[2,4], [3,0], [2,3], [1,3]],
  [[2,0], [3,0], [2,3], [1,3]],
  [[2,4], [1,4], [2,3], [3,1]],
  [[2,0], [1,4], [2,3], [3,1]],
  [[2,4], [3,0], [2,3], [3,1]],
  [[2,0], [3,0], [2,3], [3,1]],
  [[2,4], [1,4], [2,1], [1,3]],
  [[2,0], [1,4], [2,1], [1,3]],
  [[2,4], [3,0], [2,1], [1,3]],
  [[2,0], [3,0], [2,1], [1,3]],
  [[2,4], [1,4], [2,1], [3,1]],
  [[2,0], [1,4], [2,1], [3,1]],
  [[2,4], [3,0], [2,1], [3,1]],
  [[2,0], [3,0], [2,1], [3,1]],
  [[0,4], [1,4], [0,3], [1,3]],
  [[0,4], [3,0], [0,3], [1,3]],
  [[0,4], [1,4], [0,3], [3,1]],
  [[0,4], [3,0], [0,3], [3,1]],
  [[2,2], [1,2], [2,3], [1,3]],
  [[2,2], [1,2], [2,3], [3,1]],
  [[2,2], [1,2], [2,1], [1,3]],
  [[2,2], [1,2], [2,1], [3,1]],
  [[2,4], [3,4], [2,3], [3,3]],
  [[2,4], [3,4], [2,1], [3,3]],
  [[2,0], [3,4], [2,3], [3,3]],
  [[2,0], [3,4], [2,1], [3,3]],
  [[2,4], [1,4], [2,5], [1,5]],
  [[2,0], [1,4], [2,5], [1,5]],
  [[2,4], [3,0], [2,5], [1,5]],
  [[2,0], [3,0], [2,5], [1,5]],
  [[0,4], [3,4], [0,3], [3,3]],
  [[2,2], [1,2], [2,5], [1,5]],
  [[0,2], [1,2], [0,3], [1,3]],
  [[0,2], [1,2], [0,3], [3,1]],
  [[2,2], [3,2], [2,3], [3,3]],
  [[2,2], [3,2], [2,1], [3,3]],
  [[2,4], [3,4], [2,5], [3,5]],
  [[2,0], [3,4], [2,5], [3,5]],
  [[0,4], [1,4], [0,5], [1,5]],
  [[0,4], [3,0], [0,5], [1,5]],
  [[0,2], [3,2], [0,3], [3,3]],
  [[0,2], [1,2], [0,5], [1,5]],
  [[0,4], [3,4], [0,5], [3,5]],
  [[2,2], [3,2], [2,5], [3,5]],
  [[0,2], [3,2], [0,5], [3,5]],
  [[0,0], [1,0], [0,1], [1,1]],
];

export const WALL_AUTOTILE_TABLE: ShapeTable = [
  [[2,2], [1,2], [2,1], [1,1]],
  [[0,2], [1,2], [0,1], [1,1]],
  [[2,0], [1,0], [2,1], [1,1]],
  [[0,0], [1,0], [0,1], [1,1]],
  [[2,2], [3,2], [2,1], [3,1]],
  [[0,2], [3,2], [0,1], [3,1]],
  [[2,0], [3,0], [2,1], [3,1]],
  [[0,0], [3,0], [0,1], [3,1]],
  [[2,2], [1,2], [2,3], [1,3]],
  [[0,2], [1,2], [0,3], [1,3]],
  [[2,0], [1,0], [2,3], [1,3]],
  [[0,0], [1,0], [0,3], [1,3]],
  [[2,2], [3,2], [2,3], [3,3]],
  [[0,2], [3,2], [0,3], [3,3]],
  [[2,0], [3,0], [2,3], [3,3]],
  [[0,0], [3,0], [0,3], [3,3]],
];

export const WATERFALL_AUTOTILE_TABLE: ShapeTable = [
  [[2,0], [1,0], [2,1], [1,1]],
  [[0,0], [1,0], [0,1], [1,1]],
  [[2,0], [3,0], [2,1], [3,1]],
  [[0,0], [3,0], [0,1], [3,1]],
];
